import React from 'react';

import ErrorBoundary from 'components/ErrorBoundary';

export interface RenderingErrorBoundaryChildProps {
  isErrored?: boolean;
  resetErrorBoundary?: () => void;
}

class RenderingErrorBoundary extends ErrorBoundary {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
  }

  public resetErrorBoundary() {
    this.setState({ hasError: false });
  }

  public render() {
    return this.childrenWithProps({ isErrored: this.state.hasError, resetErrorBoundary: this.resetErrorBoundary });
  }

  private childrenWithProps(props: any) {
    return React.Children.map(this.props.children, (child, index) => {
      return React.isValidElement(child) ? React.cloneElement(child, props, index) : child;
    });
  }
}

export default RenderingErrorBoundary;
